/**
 * ########### 权益图标 ###########
 */
// 国内版 团队vip
export const teamVip =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip-20260601.png';

// 海外版 团队vip
export const teamIntlVip = 'https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip.png';

// 国内版 非团队vip
export const teamNotVip =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/team-vip-not-20260601.png';

// 海外版 非团队vip
export const teamIntlNotVip = 'https://x-design-static-release.stariicloud.com/xdesign-widgets/team-vip-not.png';

// 国内版 个人vip（PC内嵌）
export const userVipPc =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon-20260601.png';

// 国内版 个人vip（web端）
export const userVip =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/vip-icon-web-20260601.png';

// 海外版 个人 Basic
export const userXdesignBasic =
    'https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/basic-icon.png';

// 国内版 个人pro_vip（web端）
export const userPrpVip =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-web-20260601.png';

// 海外版 个人vip
export const userXdesignPlusVip =
    'https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/plus-icon.png';

export const userXdesignProVip =
    'https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/pro-icon.png';

export const userXdesignMaxVip =
    'https://x-design-static-release.stariicloud.com/xdesign-widgets/images/user-info/max-icon.png';

// 国内版 非个人vip（PC内嵌）
export const userNotVipPc =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon-20260601.png';

// 国内版 非个人vip（web端）
export const userNotVip =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/not-vip-icon-web-20260601.png';

// 海外版 非个人vip
export const userIntlNotVip =
    'https://x-design-static-release.stariicloud.com/xdesign-widgets/not-vip-pro-icon-intl.png';

// designkit 个人 Basic Vip
export const userBasicVipDk =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/basic-vip-icon-dk.png';

// designkit 个人 Pro Vip
export const userProVipDk =
    'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/userInfo/pro-vip-icon-dk.png';

// 身份切换引导提示缓存
export const CHANGE_IDENTITY_TIP_KEY = 'xdesign-widgets_change-identity-tip';
export const USER_INFO_SWITCH_IDENTITY_GUIDE_KEY = 'xdesign-widgets_user-info-switch-identity-guide';

export enum ChangeIdentityTipSourceEnum {
    // 运营弹窗
    PROMOTION_MODAL = 'promotionModal',
    // 美豆下拉面板
    MEIDOU_PANEL = 'meidouPanel',
}

export type ChangeIdentityTipInfoType = {
    // 触发场景： promotionModal-运营弹窗， meidouPanel-美豆下拉面板
    source: ChangeIdentityTipSourceEnum | '';
    // 是否需要展示强引导提示
    shouldShowTip: 0 | 1;
    // 是否展示过引导提示
    hasShowTipMap: {
        [key: string]: 0 | 1;
    };
};

// 记录强引导提示场景的相关状态
export const changeIdentityTipInfo: ChangeIdentityTipInfoType = {
    source: '',
    shouldShowTip: 0,
    hasShowTipMap: {
        promotionModal: 0,
        meidouPanel: 0,
    },
};
